import { type Components, type Theme } from "@mui/material/styles";

export const accordion: Components<Theme>["MuiAccordion"] = {
  defaultProps: {
    disableGutters: true,
  },
  styleOverrides: {
    root: ({ theme }) => ({
      backgroundColor: theme.palette.whiteStates.main,
      border: `1px solid ${theme.palette.divider}`,
      mb: 0,
      borderRadius: "12px 12px 0 0",
      "&:first-of-type": {
        borderRadius: "12px 12px 0 0",
      },
      boxShadow: "none",
    }),
    region: ({ theme }) => ({
      backgroundColor: theme.palette.whiteStates.main,
    }),
  },
};
